module.exports = __webpack_public_path__ + "img/no-mission-data1.cc8c0301.svg";